<template>
    <el-dialog
        title="请填写同意的原因"
        width="400px"
        :visible.sync="visible"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="同意原因：" prop="approveReason">
                <otpSelect
                    :optionArr="reasonOptions"
                    prop="approveReason"
                    placeholder="请选择原因"
                    :mValue="form.approveReason"
                    @getSelectValue="getSelectValue"
                />
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input
                    v-model="form.remark"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入备注"
                    maxlength="500"
                    show-word-limit
                />
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="btnLoading">确 认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { cloneDeep, noop } from 'lodash';
import { pictureApprove } from '@/modules/transport/otp/api/carCheck.js';
import otpSelect from '@/components/lots/otpSelect';
import { getDictOptions } from '@/modules/transport/otp/utils/dictUtil';

const FORM = {
    remark: '',
    approveReason: ''
};
export default {
    name: 'CarCheckApproveReason',
    components: { otpSelect },
    data () {
        return {
            visible: false,
            btnLoading: false,
            idList: [],
            form: cloneDeep(FORM),
            rules: {
                approveReason: [
                    { required: true, message: '请选择原因', trigger: ['blur', 'change'] }
                ],
                remark: []
            },
            reasonOptions: []
        };
    },
    created() {
        this.queryReasonDict();
    },
    methods: {
        // 同意原因字典排序
        async queryReasonDict() {
            const options = await getDictOptions('TMS_INSPECTION_APPROVE_REASON');
            options.sort((a, b) => Number(a.value) - Number(b.value));
            this.reasonOptions = options;
        },

        /**
         *
         * @param rowData 主表格中的行数据对象
         * @param attachList 附件表格中点击【同意】按钮行的附件列表
         * @param onSuccessCallback 成功回调
         */
        open(rowData, attachList, onSuccessCallback) {
            // 重置数据
            this.form = cloneDeep(FORM);
            this.attachList = attachList;
            this.rowData = rowData;
            this.onSuccessCallback = onSuccessCallback || noop;
            this.visible = true;
            // 清掉因重置触发的校验信息
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        /**
         * @description: 高级下拉选中的回调
         * @param {*} data 选中的数据
         * @return {*}
         */
        getSelectValue (data) {
            Object.assign(this.form, data);
        },
        /**
         * @description 关闭
         */
        close () {
            this.visible = false;
        },
        /**
         * @description 提交
         */
        async handleSubmit () {
            try {
                await this.$refs.form.validate();
                this.btnLoading = true;
                const res = await pictureApprove({
                    dispatchNo: this.rowData.dispatchNo, // 发车单号
                    attachmentIdList: this.attachList.map(item => item.attachmentId), // 附件id列表
                    remark: this.form.remark,
                    approveReason: this.form.approveReason
                });
                if (res && +res.code === 0) {
                    this.$message.success('操作成功');
                    if (this.onSuccessCallback) {
                        this.onSuccessCallback();
                    }
                    this.close();
                }
            } finally {
                this.btnLoading = false;
            }
        }
    }
};
</script>

<style lang="less" scoped>

</style>
